export default __webpack_public_path__ + "ff17ef2569354527d2c60581f5031a3a.png";